import type { GridValidRowModel } from '@mui/x-data-grid-pro';
import type { CustomGridColDef } from '../services';
import type { SavedColDef } from '../store';

export const mergeColumnsWithStore = <T extends GridValidRowModel>(
  storeColumns: SavedColDef[],
  defaultColumns: CustomGridColDef<T>[],
): CustomGridColDef<T>[] => {
  const columnMap = new Map(defaultColumns.map((col) => [col.field, col]));

  return storeColumns
    .map((storeColumn) => {
      const gridColumn = columnMap.get(storeColumn.field);
      return gridColumn ? ({ ...gridColumn, ...storeColumn } as CustomGridColDef<T>) : undefined;
    })
    .filter((col): col is CustomGridColDef<T> => col !== undefined);
};
